import axios from 'axios';

export default ({ reference }) => {
  return axios.post(`${process.env.VUE_APP_API_ENDPOINT}/referrals/resend-welcome-email`, { reference });
};
